import React, { Component } from 'react'
import moment from 'moment'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar, Doughnut } from 'react-chartjs-2'
import SummaryOpname from './SummaryOpname'

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend)

const C = {
  finish:   { bg: 'rgba(29,158,117,0.75)',  bd: '#1D9E75' },
  progress: { bg: 'rgba(55,138,221,0.75)',  bd: '#378ADD' },
  belum:    { bg: 'rgba(136,135,128,0.75)', bd: '#888780' },
  rejected: { bg: 'rgba(226,75,74,0.75)',   bd: '#E24B4A' },
  revisi:   { bg: 'rgba(239,159,39,0.75)',  bd: '#EF9F27' },
  disposal: { bg: 'rgba(212,83,126,0.75)',  bd: '#D4537E' },
  ada:      { bg: 'rgba(29,158,117,0.75)',  bd: '#1D9E75' },
  tidakAda: { bg: 'rgba(226,75,74,0.75)',   bd: '#E24B4A' },
  baik:     { bg: 'rgba(29,158,117,0.75)',  bd: '#1D9E75' },
  rusak:    { bg: 'rgba(226,75,74,0.75)',   bd: '#E24B4A' },
  sedang:   { bg: 'rgba(239,159,39,0.75)',  bd: '#EF9F27' },
  none:     { bg: 'rgba(180,178,169,0.75)', bd: '#B4B2A9' },
  acquis:   { bg: 'rgba(55,138,221,0.75)',  bd: '#378ADD' },
  buku:     { bg: 'rgba(29,158,117,0.75)',  bd: '#1D9E75' },
}

const BUCKETS     = ['Finish', 'In Progress', 'Belum submit', 'Rejected', 'Revisi', 'Disposal']
const BUCKET_KEYS = ['finish', 'progress', 'belum', 'rejected', 'revisi', 'disposal']

function bucketStatus(s) {
  if (!s)                     return 'Belum submit'
  if (s.includes('Finish'))   return 'Finish'
  if (s.includes('Rejected')) return 'Rejected'
  if (s.includes('Revisi'))   return 'Revisi'
  if (s.includes('Disposal')) return 'Disposal'
  if (s.includes('Progress')) return 'In Progress'
  return 'Belum submit'
}

function toNum(v) { const n = parseFloat(v); return isNaN(n) ? 0 : n }

function fmtCompact(n) {
  const v = toNum(n)
  if (v === 0) return '0'
  if (Math.abs(v) >= 1e9) return (v / 1e9).toFixed(1) + 'M'
  if (Math.abs(v) >= 1e6) return (v / 1e6).toFixed(1) + 'jt'
  if (Math.abs(v) >= 1e3) return (v / 1e3).toFixed(0) + 'rb'
  return String(Math.round(v))
}

function fmtRupiah(n) {
  return 'Rp ' + new Intl.NumberFormat('id-ID').format(Math.round(toNum(n)))
}

const S = {
  wrap:        { padding: '0 0 24px 0' },
  topBar:      { display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center', marginBottom: 14, padding: '10px 14px', background: '#f8f8f7', borderRadius: 8, border: '0.5px solid #e0e0e0' },
  divider:     { width: 1, height: 22, background: '#ddd', margin: '0 4px' },
  label:       { fontSize: 12, color: '#666', fontWeight: 500, whiteSpace: 'nowrap' },
  sel:         { fontSize: 12, padding: '5px 10px', borderRadius: 6, border: '0.5px solid #ccc', background: '#fff', cursor: 'pointer', color: '#333' },
  goBtn:       { fontSize: 12, padding: '5px 14px', borderRadius: 6, cursor: 'pointer', border: '0.5px solid #2563EB', background: '#2563EB', color: '#fff', fontWeight: 500 },
  goBtnOff:    { fontSize: 12, padding: '5px 14px', borderRadius: 6, border: '0.5px solid #ccc', background: '#f0f0f0', color: '#aaa', cursor: 'not-allowed' },
  periodeInfo: { fontSize: 11, color: '#999' },
  metricGrid:  { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: 10, marginBottom: 14 },
  metricCard:  { background: '#f4f4f2', borderRadius: 8, padding: '12px 14px', border: '0.5px solid transparent' },
  metricLbl:   { fontSize: 11, color: '#888', marginBottom: 5 },
  metricVal:   { fontSize: 22, fontWeight: 500, color: '#222' },
  metricSub:   { fontSize: 11, color: '#aaa', marginTop: 2 },
  chartRow:    { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 },
  card:        { background: '#fff', border: '0.5px solid #e0e0e0', borderRadius: 10, padding: '14px 16px' },
  cardMb:      { background: '#fff', border: '0.5px solid #e0e0e0', borderRadius: 10, padding: '14px 16px', marginBottom: 12 },
  cardNoClick: { background: '#fff', border: '0.5px solid #e0e0e0', borderRadius: 10, padding: '14px 16px', marginBottom: 12 },
  cardTitle:   { fontSize: 12, fontWeight: 500, color: '#666', marginBottom: 8 },
  legend:      { display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 8 },
  legItem:     { display: 'flex', alignItems: 'center', gap: 5, fontSize: 11, color: '#666' },
  legDot:      { width: 10, height: 10, borderRadius: 2, flexShrink: 0 },
  tbl:         { width: '100%', borderCollapse: 'collapse', fontSize: 12 },
  th:          { textAlign: 'left', padding: '7px 10px', fontWeight: 500, fontSize: 11, color: '#888', borderBottom: '0.5px solid #e0e0e0', background: '#fafafa' },
  td:          { padding: '7px 10px', borderBottom: '0.5px solid #f0f0f0', color: '#333', verticalAlign: 'middle' },
}

class StockDashboard extends Component {
  constructor(props) {
    super(props)
    const now       = moment()
    const isAfter25 = parseInt(now.format('DD')) >= 25
    const initMonth = isAfter25 ? now.month() + 1 : now.month()
    const initYear  = now.year()
    const time1     = moment(`${initYear}-${initMonth}-26`, 'YYYY-M-DD').format('YYYY-MM-DD')
    const time2     = moment(`${initYear}-${initMonth + 1}-25`, 'YYYY-M-DD').format('YYYY-MM-DD')

    this.state = {
      filterPlant: 'all',
      selectMonth: initMonth,
      selectYear:  initYear,
      time1: props.time1 || time1,
      time2: props.time2 || time2,
    }
  }

  handleMonth = (e) => {
    const selectMonth = parseInt(e.target.value)
    const { selectYear } = this.state
    const time1 = moment(`${selectYear}-${selectMonth}-26`, 'YYYY-M-DD').format('YYYY-MM-DD')
    const time2 = moment(`${selectYear}-${selectMonth + 1}-25`, 'YYYY-M-DD').format('YYYY-MM-DD')
    this.setState({ selectMonth, time1, time2 })
  }

  handleYear = (e) => {
    const selectYear = parseInt(e.target.value)
    const { selectMonth } = this.state
    const time1 = moment(`${selectYear}-${selectMonth}-26`, 'YYYY-M-DD').format('YYYY-MM-DD')
    const time2 = moment(`${selectYear}-${selectMonth + 1}-25`, 'YYYY-M-DD').format('YYYY-MM-DD')
    this.setState({ selectYear, time1, time2 })
  }

  handleGo = () => {
    const { time1, time2, selectMonth, selectYear } = this.state
    if (this.props.onPeriodeChange) this.props.onPeriodeChange({ time1, time2, selectMonth, selectYear })
  }

  getFiltered() {
    const { newReport = [] } = this.props
    const { filterPlant }   = this.state
    return newReport.filter(x => filterPlant === 'all' || x.kode_plant === filterPlant)
  }

  getPlants() {
    const { newReport = [] } = this.props
    return [...new Set(newReport.map(x => x.kode_plant).filter(Boolean))].sort()
  }

  getMetrics(f) {
    const total    = f.length
    const finish   = f.filter(x => bucketStatus(x.new_status) === 'Finish').length
    const progress = f.filter(x => bucketStatus(x.new_status) === 'In Progress').length
    const belum    = f.filter(x => bucketStatus(x.new_status) === 'Belum submit').length
    const rejected = f.filter(x => bucketStatus(x.new_status) === 'Rejected').length
    const revisi   = f.filter(x => bucketStatus(x.new_status) === 'Revisi').length
    const acquis   = f.reduce((s, x) => s + toNum(x.nilai_acquis), 0)
    const buku     = f.reduce((s, x) => s + toNum(x.nilai_buku), 0)
    const pct      = total > 0 ? Math.round(finish / total * 100) : 0
    return [
      { label: 'Total Aset',   val: total,                       sub: '' },
      { label: 'Finish',       val: finish,                      sub: pct + '% selesai', color: '#1D9E75' },
      { label: 'In Progress',  val: progress,                    sub: '',                color: '#378ADD' },
      { label: 'Belum Submit', val: belum,                       sub: '',                color: '#888780' },
      { label: 'Rejected',     val: rejected,                    sub: '',                color: '#E24B4A' },
      { label: 'Revisi',       val: revisi,                      sub: '',                color: '#EF9F27' },
      { label: 'Acquis Val',   val: 'Rp ' + fmtCompact(acquis), sub: '' },
      { label: 'Book Val',     val: 'Rp ' + fmtCompact(buku),   sub: '' },
    ]
  }

  getGroupingData(f) {
    const groups = [...new Set(f.map(x => x.grouping).filter(Boolean))].sort()
    return {
      data: {
        labels: groups,
        datasets: BUCKETS.map((b, i) => ({
          label: b,
          data:  groups.map(g => f.filter(x => x.grouping === g && bucketStatus(x.new_status) === b).length),
          backgroundColor: C[BUCKET_KEYS[i]].bg,
          borderColor:     C[BUCKET_KEYS[i]].bd,
          borderWidth: 1,
        })),
      },
      options: {
        responsive: true, maintainAspectRatio: false,
        plugins: { legend: { display: true, position: 'top', labels: { font: { size: 11 }, boxWidth: 12, padding: 10 } } },
        scales: {
          x: { stacked: true, ticks: { font: { size: 10 }, maxRotation: 30 } },
          y: { stacked: true, beginAtZero: true, ticks: { stepSize: 1, font: { size: 10 } } },
        },
      },
    }
  }

  getFisikData(f) {
    return {
      data: {
        labels: ['Status Fisik', 'Status SAP'],
        datasets: [
          { label: 'Ada',       data: [f.filter(x => x.status_fisik === 'ada' || x.new_status === 'Belum submit').length, f.filter(x => x.new_status === 'Belum submit' || x.status_doc !== 1).length], backgroundColor: C.ada.bg,      borderColor: C.ada.bd,      borderWidth: 1 },
          { label: 'Tidak Ada', data: [f.filter(x => x.status_fisik === 'tidak ada').length, f.filter(x => x.status_doc === 1).length], backgroundColor: C.tidakAda.bg, borderColor: C.tidakAda.bd, borderWidth: 1 },
        ],
      },
      options: {
        responsive: true, maintainAspectRatio: false,
        plugins: { legend: { display: true, position: 'top', labels: { font: { size: 11 }, boxWidth: 12, padding: 10 } } },
        scales: { x: { stacked: true }, y: { stacked: true, beginAtZero: true } },
      },
    }
  }

  getKondisiData(f) {
    return {
      data: {
        labels: ['Baik', 'Rusak', 'Tidak Ada', 'Belum Isi'],
        datasets: [{
          data: [f.filter(x => x.kondisi === 'baik').length, f.filter(x => x.kondisi === 'rusak').length, f.filter(x => (x.kondisi === 'tidak ada' || x.kondisi === '')).length, f.filter(x => !x.kondisi).length],
          backgroundColor: [C.baik.bg, C.rusak.bg, C.sedang.bg, C.none.bg],
          borderColor:     [C.baik.bd, C.rusak.bd, C.sedang.bd, C.none.bd],
          borderWidth: 1,
        }],
      },
      options: {
        responsive: true, maintainAspectRatio: false,
        plugins: { legend: { display: true, position: 'top', labels: { font: { size: 11 }, boxWidth: 12, padding: 10 } } },
        cutout: '60%',
      },
    }
  }

  getStatusData(f) {
    const counts = BUCKETS.map(b => f.filter(x => bucketStatus(x.new_status) === b).length)
    return {
      counts,
      data: {
        labels: BUCKETS.map((b, i) => `${b} (${counts[i]})`),
        datasets: [{ data: counts, backgroundColor: BUCKET_KEYS.map(k => C[k].bg), borderColor: BUCKET_KEYS.map(k => C[k].bd), borderWidth: 1 }],
      },
      options: {
        responsive: true, maintainAspectRatio: false,
        plugins: { legend: { display: true, position: 'top', labels: { font: { size: 11 }, boxWidth: 12, padding: 10 } } },
        cutout: '55%',
      },
    }
  }

  getPlantData(f) {
    // Hitung total acquis per plant dulu
    const plantMap = new Map()
    f.forEach(x => {
        if (!x.kode_plant) return
        if (!plantMap.has(x.kode_plant)) {
            plantMap.set(x.kode_plant, { area: x.area, acquis: 0, buku: 0 })
        }
        const entry = plantMap.get(x.kode_plant)
        entry.acquis += toNum(x.nilai_acquis)
        entry.buku   += toNum(x.nilai_buku)
    })

    // Sort by acquis descending, ambil top 10
    const top10 = [...plantMap.entries()]
        .sort(([, a], [, b]) => b.acquis - a.acquis)
        .slice(0, 10)

    const plants = top10.map(([p]) => p)
    const labels = top10.map(([p, v]) => v.area ? `${p} - ${v.area}` : p)

    return {
      height: Math.max(plants.length * 50 + 80, 200),
      data: {
          labels,
          datasets: [
              { label: 'Acquis Val', data: top10.map(([, v]) => Math.round(v.acquis)), backgroundColor: C.acquis.bg, borderColor: C.acquis.bd, borderWidth: 1 },
              { label: 'Book Val',   data: top10.map(([, v]) => Math.round(v.buku)),   backgroundColor: C.buku.bg,   borderColor: C.buku.bd,   borderWidth: 1 },
          ],
      },
      options: {
        indexAxis: 'y', responsive: true, maintainAspectRatio: false,
        plugins: { legend: { position: 'top', labels: { font: { size: 11 }, boxWidth: 12 } } },
        scales: {
          x: { beginAtZero: true, ticks: { callback: v => 'Rp ' + fmtCompact(v), font: { size: 10 } } },
          y: { ticks: { font: { size: 11 } } },
        },
      },
    }
  }

  getSummaryRows(f) {
    return [...new Set(f.map(x => x.kode_plant).filter(Boolean))].sort().map(p => {
      const items = f.filter(x => x.kode_plant === p)
      console.log(items)
      return {
        plant:    p,
        area:     items[0].area,
        total:    items.length,
        finish:   items.filter(x => bucketStatus(x.new_status) === 'Finish').length,
        progress: items.filter(x => bucketStatus(x.new_status) === 'In Progress').length,
        belum:    items.filter(x => bucketStatus(x.new_status) === 'Belum submit').length,
        rejected: items.filter(x => bucketStatus(x.new_status) === 'Rejected').length,
        acquis:   items.reduce((s, x) => s + toNum(x.nilai_acquis), 0),
        buku:     items.reduce((s, x) => s + toNum(x.nilai_buku), 0),
      }
    })
  }

  renderLegend(items) {
    return (
      <div style={S.legend}>
        {items.map((it, i) => (
          <span key={i} style={S.legItem}>
            <span style={{ ...S.legDot, background: it.color }} />
            {it.label}
          </span>
        ))}
      </div>
    )
  }

  render() {
    const { filterPlant, selectMonth, selectYear, time1, time2 } = this.state
    const filtered    = this.getFiltered()
    const plants      = this.getPlants()
    const metrics     = this.getMetrics(filtered)
    const grouping    = this.getGroupingData(filtered)
    const fisik       = this.getFisikData(filtered)
    const kondisi     = this.getKondisiData(filtered)
    const status      = this.getStatusData(filtered)
    const plant       = this.getPlantData(filtered)
    const summaryRows = this.getSummaryRows(filtered)

    const months      = moment.locale('id') && moment.months()
    const currentYear = moment().year()
    const years       = []
    for (let y = 2000; y <= currentYear; y++) years.push(y)

    const canGo    = time1 !== '' && time2 !== ''

    return (
      <div style={S.wrap}>

        {/* ── Top bar: hanya periode + filter plant, tanpa toggle type ── */}
        <div style={S.topBar}>
          <span style={S.label}>Tampilan:</span>
          <div style={{ display: 'flex', border: '0.5px solid #ccc', borderRadius: 6, overflow: 'hidden' }}>
            {['dashboard', 'detail_report'].map((t, i) => (
              <button
                key={t}
                style={{ fontSize: 12, padding: '5px 14px', cursor: 'pointer', border: 'none', background: (this.props.typeReport || 'dashboard') === t ? '#2563EB' : '#fff', color: (this.props.typeReport || 'dashboard') === t ? '#fff' : '#555', fontWeight: (this.props.typeReport || 'dashboard') === t ? 500 : 400 }}
                onClick={() => this.props.onTypeChange && this.props.onTypeChange(t)}
              >
                {t === 'dashboard' ? 'Dashboard' : 'Detail Report'}
              </button>
            ))}
          </div>

          <div style={S.divider} />
          <span style={S.label}>Periode:</span>
          <select style={S.sel} value={selectMonth} onChange={this.handleMonth}>
            <option value=''>Pilih Bulan</option>
            {months.map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
          </select>
          <select style={S.sel} value={selectYear} onChange={this.handleYear}>
            <option value=''>Pilih Tahun</option>
            {years.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <button style={canGo ? S.goBtn : S.goBtnOff} disabled={!canGo} onClick={this.handleGo}>Go</button>
          {time1 && time2 && (
            <span style={S.periodeInfo}>{moment(time1).format('DD MMM YY')} – {moment(time2).format('DD MMM YY')}</span>
          )}

          <div style={S.divider} />

          <span style={S.label}>Plant:</span>
          <select style={S.sel} value={filterPlant} onChange={e => this.setState({ filterPlant: e.target.value })}>
            <option value='all'>Semua</option>
            {plants.map(p => <option key={p} value={p}>{p}</option>)}
          </select>
          <span style={{ fontSize: 11, color: '#999' }}>{filtered.length} aset</span>

          <div style={S.divider} />

          <div style={{ display: 'flex', border: '0.5px solid #ccc', borderRadius: 6, overflow: 'hidden' }}>
            <button
                style={{ fontSize: 12, padding: '5px 14px', cursor: 'pointer', border: 'none', background: '#2563EB', color: '#fff', fontWeight: 500 }}
                onClick={() => this.props.downloadReport()}
              >
                Download Report
              </button>
          </div>
        </div>

        {/* ── Metric cards (read-only, no drill) ── */}
        <div style={S.metricGrid}>
          {metrics.map((m, i) => (
            <div key={i} style={S.metricCard}>
              <div style={S.metricLbl}>{m.label}</div>
              <div style={{ ...S.metricVal, color: m.color || '#222' }}>{m.val}</div>
              {m.sub && <div style={S.metricSub}>{m.sub}</div>}
            </div>
          ))}
        </div>

        <div style={S.chartRow}>
          <div style={S.card}>
            <div style={S.cardTitle}>Status per grouping</div>
            <div style={{ position: 'relative', height: 220 }}>
              <Bar data={grouping.data} options={grouping.options} />
            </div>
          </div>
          <div style={S.card}>
            <div style={S.cardTitle}>Status fisik vs SAP</div>
            <div style={{ position: 'relative', height: 220 }}>
              <Bar data={fisik.data} options={fisik.options} />
            </div>
          </div>
        </div>

        <div style={S.chartRow}>
          <div style={S.card}>
            <div style={S.cardTitle}>Kondisi aset</div>
            <div style={{ position: 'relative', height: 200 }}>
              <Doughnut data={kondisi.data} options={kondisi.options} />
            </div>
          </div>
          <div style={S.card}>
            <div style={S.cardTitle}>Status submit</div>
            <div style={{ position: 'relative', height: 200 }}>
              <Doughnut data={status.data} options={status.options} />
            </div>
          </div>
        </div>

        {/* ── Summary Opname ── */}
        <div style={{ ...S.cardNoClick, marginBottom: 16 }}>
          <SummaryOpname
            newReport={this.props.newReport || []}
            periodeLabel={`Bulan ${moment().month(selectMonth - 1).format('MMMM')} ${selectYear}`}
            time2={time2}
          />
        </div>

        <div style={S.cardMb}>
          <div style={S.cardTitle}>Nilai aset per cost center (top 10)</div>
          <div style={{ position: 'relative', height: plant.height }}>
            <Bar data={plant.data} options={plant.options} />
          </div>
        </div>

        <div style={S.cardNoClick}>
          <div style={S.cardTitle}>Ringkasan per plant</div>
          <div style={{ overflowX: 'auto' }}>
            <table style={S.tbl}>
              <thead>
                <tr>{['No', 'Plant','Total','Finish','In Progress','Belum Submit','Rejected','Acquis Val','Book Val'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {summaryRows.map((r, i) => (
                  <tr key={i}>
                    <td style={{ ...S.td}}>{i + 1}</td>
                    <td style={{ ...S.td, fontWeight: 500 }}>{r.plant}-{r.area}</td>
                    <td style={S.td}>{r.total}</td>
                    <td style={{ ...S.td, color: '#1D9E75', fontWeight: 500 }}>{r.finish}</td>
                    <td style={{ ...S.td, color: '#378ADD' }}>{r.progress}</td>
                    <td style={{ ...S.td, color: '#888780' }}>{r.belum}</td>
                    <td style={{ ...S.td, color: '#E24B4A' }}>{r.rejected}</td>
                    <td style={{ ...S.td, fontSize: 11 }}>{fmtRupiah(r.acquis)}</td>
                    <td style={{ ...S.td, fontSize: 11 }}>{fmtRupiah(r.buku)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    )
  }
}

export default StockDashboard